/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PromptGroupType } from './PromptGroupType';
import {
    PromptGroupTypeFromJSON,
    PromptGroupTypeFromJSONTyped,
    PromptGroupTypeToJSON,
} from './PromptGroupType';
import type { PromptQuestion } from './PromptQuestion';
import {
    PromptQuestionFromJSON,
    PromptQuestionFromJSONTyped,
    PromptQuestionToJSON,
} from './PromptQuestion';

/**
 * 
 * @export
 * @interface PromptGroup
 */
export interface PromptGroup {
    /**
     * 
     * @type {Array<PromptQuestion>}
     * @memberof PromptGroup
     */
    questions: Array<PromptQuestion>;
    /**
     * 
     * @type {PromptGroupType}
     * @memberof PromptGroup
     */
    promptGroupType: PromptGroupType;
    /**
     * 
     * @type {number}
     * @memberof PromptGroup
     */
    totalWeight: number;
}


/**
 * Check if a given object implements the PromptGroup interface.
 */
export function instanceOfPromptGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "questions" in value;
    isInstance = isInstance && "promptGroupType" in value;
    isInstance = isInstance && "totalWeight" in value;

    return isInstance;
}

export function PromptGroupFromJSON(json: any): PromptGroup {
    return PromptGroupFromJSONTyped(json, false);
}

export function PromptGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'questions': ((json['questions'] as Array<any>).map(PromptQuestionFromJSON)),
        'promptGroupType': PromptGroupTypeFromJSON(json['promptGroupType']),
        'totalWeight': json['totalWeight'],
    };
}

export function PromptGroupToJSON(value?: PromptGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'questions': ((value.questions as Array<any>).map(PromptQuestionToJSON)),
        'promptGroupType': PromptGroupTypeToJSON(value.promptGroupType),
        'totalWeight': value.totalWeight,
    };
}

